export const DEFAULT_SERVER_IP = "irc.swiftirc.net";
export const DEFAULT_SERVER_PORT = 4443;
export const DEFAULT_NICKNAME = "LCPlayer";
export const DEFAULT_CHANNELS = "#LostCity,#LostHQ";
export const MAX_RECONNECT_ATTEMPTS = 5;

export const DEFAULT_MAX_MESSAGES_PER_TAB = 1000;

export const IRC_COLORS = [
  "#ffffff", // 0: White
  "#000000", // 1: Black
  "#000080", // 2: Blue
  "#008000", // 3: Green
  "#ff0000", // 4: Red
  "#800000", // 5: Brown
  "#800080", // 6: Purple
  "#ffa500", // 7: Orange
  "#ffff00", // 8: Yellow
  "#00ff00", // 9: Light Green
  "#008080", // 10: Cyan
  "#00ffff", // 11: Light Cyan
  "#0000ff", // 12: Light Blue
  "#ff00ff", // 13: Pink
  "#808080", // 14: Grey
  "#c0c0c0", // 15: Light Grey
];

export const IRC_FORMATTING = {
  BOLD: "\x02",
  ITALIC: "\x1D",
  UNDERLINE: "\x1F",
  COLOR: "\x03",
  RESET: "\x0F",
  REVERSE: "\x16",
};
